export default {
  color: {
    bg: {
      page: {
        color: '#fafafa',
      },
      btn: {
        secondary: {
          default: {
            color: '#ffffff00',
          },
          hover: {
            color: '#F2F2F2',
          },
          disabled: {
            color: '#ffffff00',
          },
        },
        primary: {
          default: {
            color: '#313131',
          },
          hover: {
            color: '#232323',
          },
          disabled: {
            color: '#DBDBDB',
          },
        },
      },
      spinner: {
        color: '#313131',
      },
      circle_btn: {
        secondary: {
          default: {
            color: '#fff',
          },
        },
      },
      check_box: {
        hover: {
          color: '#ffffff00',
        },
        default: {
          color: '#ffffff00',
        },
        checked: {
          color: '#ffffff00',
        },
        disabled: {
          color: '#ffffff00',
        },
      },
      island: {
        filled: {
          primary: {
            color: '#fff',
          },
          secondary: {
            color: '#F2F2F2',
          },
        },
      },
      chips: {
        default: {
          color: '#F2F2F2',
        },
        hover: {
          color: '#EEEEEE',
        },
      },
      input: {
        default: {
          color: '#ffffff00',
        },
        disabled: {
          color: '#F5F5F5',
        },
      },
      scroll: {
        default: {
          color: '#E8E8E8',
        },
      },
      list_item: {
        start_gradient: {
          color: '#f5f5f500',
        },
        white_bg: {
          hover: {
            color: '#f5f5f5',
          },
        },
        color_bg: {
          hover: {
            color: '#f2f2f2',
          },
        },
      },
      drawer: {
        default: {
          color: '#fafafa',
        },
        dimmer: {
          color: '#00000032',
        },
      },
      menu_item: {
        secondary: {
          hover: {
            color: '#F2F2F2',
          },
          selected: {
            color: '#F2F2F2',
          },
        },
      },
    },
    font: {
      light_bg: {
        primary: {
          default: {
            color: '#313131',
          },
          disabled: {
            color: '#A8A8A8',
          },
        },
        secondary: {
          default: {
            color: '#868686',
          },
          disabled: {
            color: '#B3B3B3',
          },
        },
        label: {
          default: {
            color: '#B3B3B3',
          },
        },
      },
      dark_bg: {
        secondary: {
          default: {
            color: '#868686',
          },
          disabled: {
            color: '#999999',
          },
        },
        primary: {
          default: {
            color: '#fff',
          },
          disabled: {
            color: '#999999',
          },
        },
        label: {
          default: {
            color: '#B3B3B3',
          },
        },
      },
      link: {
        default: {
          color: '#217AAC',
        },
        hover: {
          color: '#226489',
        },
      },
    },
    icon: {
      light_bg: {
        primary: {
          default: {
            color: '#313131',
          },
          disabled: {
            color: '#A8A8A8',
          },
        },
        secondary: {
          default: {
            color: '#868686',
          },
          hover: {
            color: '#313131',
          },
          disabled: {
            color: '#B3B3B3',
          },
        },
      },
      dark_bg: {
        secondary: {
          default: {
            color: '#868686',
          },
          disabled: {
            color: '#999999',
          },
        },
        primary: {
          default: {
            color: '#fff',
          },
          disabled: {
            color: '#999999',
          },
        },
      },
    },
    common: {
      primary: {
        error: {
          color: '#F35B1A',
        },
        success: {
          color: '#7CA525',
        },
        waiting: {
          color: '#FDA118',
        },
      },
      secondary: {
        error: {
          color: '#F9E2D8',
        },
        success: {
          color: '#E7EFD6',
        },
        waiting: {
          color: '#FAEDD8',
        },
      },
    },
  },
  text: {
    body: {
      '500': {
        default: {
          typography: {
            fontFamily: 'inter',
            fontWeight: '500',
            lineHeight: '24px',
            fontSize: '17px',
          },
        },
        long: {
          typography: {
            fontFamily: 'inter',
            fontWeight: '500',
            lineHeight: '28px',
            fontSize: '17px',
          },
        },
      },
      '600': {
        default: {
          typography: {
            fontFamily: 'inter',
            fontWeight: '600',
            lineHeight: '24px',
            fontSize: '17px',
          },
        },
      },
    },
    accent: {
      '1': {
        typography: {
          fontFamily: 'Inter',
          fontWeight: '800',
          lineHeight: '78px',
          fontSize: '80px',
        },
      },
      '2': {
        typography: {
          fontFamily: 'Inter',
          fontWeight: '800',
          lineHeight: '68px',
          fontSize: '68px',
        },
      },
    },
    h1: {
      typography: {
        fontFamily: 'inter',
        fontWeight: '700',
        lineHeight: '52px',
        fontSize: '52px',
      },
    },
    h2: {
      typography: {
        fontFamily: 'inter',
        fontWeight: '700',
        lineHeight: '40px',
        fontSize: '36px',
      },
    },
    h3: {
      typography: {
        fontFamily: 'inter',
        fontWeight: '700',
        lineHeight: '28px',
        fontSize: '24px',
      },
    },
    caption: {
      '500': {
        typography: {
          fontFamily: 'Inter',
          fontWeight: '500',
          lineHeight: '20px',
          fontSize: '15px',
        },
      },
      '600': {
        typography: {
          fontFamily: 'Inter',
          fontWeight: '600',
          lineHeight: '20px',
          fontSize: '15px',
        },
      },
    },
  },
  border_radius: {
    s: {
      borderRadius: '6px',
    },
    m: {
      borderRadius: '16px',
    },
    l: {
      borderRadius: '20px',
    },
  },
  height: {
    btn: {
      l: {
        sizing: '72px',
      },
      m: {
        sizing: '64px',
      },
      s: {
        sizing: '48px',
      },
      text: {
        sizing: '48px',
      },
    },
    chips: {
      desktop: {
        sizing: '40px',
      },
    },
    text_input: {
      desktop: {
        sizing: '68px',
      },
    },
    list_item: {
      m: {
        sizing: '64px',
      },
      l: {
        sizing: '72px',
      },
    },
  },
  horizontal_padding: {
    btn: {
      general: {
        m: {
          sizing: '32px',
        },
        s: {
          sizing: '24px',
        },
      },
      text: {
        m: {
          sizing: '16px',
        },
      },
    },
    drawer: {
      m: {
        sizing: '56px',
      },
    },
    accordion: {
      m: {
        sizing: '32px',
      },
    },
  },
  shadow: {
    z1: {
      boxShadow: '0 8px 20px 0 #00000005',
    },
    z2: {
      boxShadow: '0 8px 25px 0 #0000000F',
    },
  },
  size: {
    icon: {
      btn: {
        sizing: '24px',
      },
      chips: {
        sizing: '20px',
      },
      input: {
        sizing: '24px',
      },
      list_item: {
        m: {
          sizing: '48px',
        },
        l: {
          sizing: '56px',
        },
      },
      vertical_text_to_copy: {
        sizing: '20px',
      },
    },
  },
  border: {
    btn: {
      secondary: {
        default: {
          border: {
            color: '#313131',
            width: '1px',
          },
        },
        hover: {
          border: {
            color: '#313131',
            width: '1px',
          },
        },
        disabled: {
          border: {
            color: '#C7C7C7',
            width: '1px',
          },
        },
      },
    },
    check_box: {
      default: {
        border: {
          color: '#D9D9D9',
          width: '1px',
        },
      },
      hover: {
        border: {
          color: '#313131',
          width: '1px',
        },
      },
      checked: {
        border: {
          color: '#D9D9D9',
          width: '1px',
        },
      },
      disabled: {
        border: {
          color: '#E6E6E6',
          width: '1px',
        },
      },
      error: {
        border: {
          color: '#F35B1A',
          width: '1px',
        },
      },
    },
    input: {
      default: {
        border: {
          color: '#D9D9D9',
          width: '1px',
        },
      },
      disabled: {
        border: {
          color: '#E6E6E6',
          width: '1px',
        },
      },
      error: {
        border: {
          color: '#F35B1A',
          width: '1px',
        },
      },
      focus: {
        border: {
          color: '#313131',
          width: '1px',
        },
      },
    },
    chips: {
      default: {
        border: {
          color: '#D9D9D9',
          width: '1px',
        },
      },
      disabled: {
        border: {
          color: '#E6E6E6',
          width: '1px',
        },
      },
    },
    big_block: {
      outlined: {
        default: {
          border: {
            color: '#ECECEC',
            width: '1px',
          },
        },
      },
    },
    menu_item: {
      secondary: {
        selected: {
          border: {
            width: '1px',
            color: '#E8E8E8',
          },
        },
      },
    },
  },
  vertical_padding: {
    accordion: {
      m: {
        sizing: '24px',
      },
    },
  },
  animation: {
    s: {
      animation: '100ms ease-in-out',
    },
    m: {
      animation: '300ms ease-in-out',
    },
  },
  version: {
    other: '23_04_07_1',
  },
}
export const raw = {
  color: {
    bg: {
      page: {
        value: '#fafafa',
        type: 'color',
      },
      btn: {
        secondary: {
          default: {
            value: '#ffffff00',
            type: 'color',
          },
          hover: {
            value: '#F2F2F2',
            type: 'color',
          },
          disabled: {
            value: '#ffffff00',
            type: 'color',
          },
        },
        primary: {
          default: {
            value: '#313131',
            type: 'color',
          },
          hover: {
            value: '#232323',
            type: 'color',
          },
          disabled: {
            value: '#DBDBDB',
            type: 'color',
          },
        },
      },
      spinner: {
        value: '#313131',
        type: 'color',
      },
      circle_btn: {
        secondary: {
          default: {
            value: '#fff',
            type: 'color',
          },
        },
      },
      check_box: {
        hover: {
          value: '#ffffff00',
          type: 'color',
        },
        default: {
          value: '#ffffff00',
          type: 'color',
        },
        checked: {
          value: '#ffffff00',
          type: 'color',
        },
        disabled: {
          value: '#ffffff00',
          type: 'color',
        },
      },
      island: {
        filled: {
          primary: {
            value: '#fff',
            type: 'color',
          },
          secondary: {
            value: '#F2F2F2',
            type: 'color',
          },
        },
      },
      chips: {
        default: {
          value: '#F2F2F2',
          type: 'color',
        },
        hover: {
          value: '#EEEEEE',
          type: 'color',
        },
      },
      input: {
        default: {
          value: '#ffffff00',
          type: 'color',
        },
        disabled: {
          value: '#F5F5F5',
          type: 'color',
        },
      },
      scroll: {
        default: {
          value: '#E8E8E8',
          type: 'color',
        },
      },
      list_item: {
        start_gradient: {
          value: '#f5f5f500',
          type: 'color',
        },
        white_bg: {
          hover: {
            value: '#f5f5f5',
            type: 'color',
          },
        },
        color_bg: {
          hover: {
            value: '#f2f2f2',
            type: 'color',
          },
        },
      },
      drawer: {
        default: {
          value: '#fafafa',
          type: 'color',
        },
        dimmer: {
          value: '#00000032',
          type: 'color',
        },
      },
      menu_item: {
        secondary: {
          hover: {
            value: '#F2F2F2',
            type: 'color',
          },
          selected: {
            value: '#F2F2F2',
            type: 'color',
          },
        },
      },
    },
    font: {
      light_bg: {
        primary: {
          default: {
            value: '#313131',
            type: 'color',
          },
          disabled: {
            value: '#A8A8A8',
            type: 'color',
          },
        },
        secondary: {
          default: {
            value: '#868686',
            type: 'color',
          },
          disabled: {
            value: '#B3B3B3',
            type: 'color',
          },
        },
        label: {
          default: {
            value: '#B3B3B3',
            type: 'color',
          },
        },
      },
      dark_bg: {
        secondary: {
          default: {
            value: '#868686',
            type: 'color',
          },
          disabled: {
            value: '#999999',
            type: 'color',
          },
        },
        primary: {
          default: {
            value: '#fff',
            type: 'color',
          },
          disabled: {
            value: '#999999',
            type: 'color',
          },
        },
        label: {
          default: {
            value: '#B3B3B3',
            type: 'color',
          },
        },
      },
      link: {
        default: {
          value: '#217AAC',
          type: 'color',
        },
        hover: {
          value: '#226489',
          type: 'color',
        },
      },
    },
    icon: {
      light_bg: {
        primary: {
          default: {
            value: '#313131',
            type: 'color',
          },
          disabled: {
            value: '#A8A8A8',
            type: 'color',
          },
        },
        secondary: {
          default: {
            value: '#868686',
            type: 'color',
          },
          hover: {
            value: '#313131',
            type: 'color',
          },
          disabled: {
            value: '#B3B3B3',
            type: 'color',
          },
        },
      },
      dark_bg: {
        secondary: {
          default: {
            value: '#868686',
            type: 'color',
          },
          disabled: {
            value: '#999999',
            type: 'color',
          },
        },
        primary: {
          default: {
            value: '#fff',
            type: 'color',
          },
          disabled: {
            value: '#999999',
            type: 'color',
          },
        },
      },
    },
    common: {
      primary: {
        error: {
          value: '#F35B1A',
          type: 'color',
        },
        success: {
          value: '#7CA525',
          type: 'color',
        },
        waiting: {
          value: '#FDA118',
          type: 'color',
        },
      },
      secondary: {
        error: {
          value: '#F9E2D8',
          type: 'color',
        },
        success: {
          value: '#E7EFD6',
          type: 'color',
        },
        waiting: {
          value: '#FAEDD8',
          type: 'color',
        },
      },
    },
  },
  text: {
    body: {
      '500': {
        default: {
          value: {
            fontFamily: 'inter',
            fontWeight: '500',
            lineHeight: '24px',
            fontSize: '17px',
          },
          type: 'typography',
        },
        long: {
          value: {
            fontFamily: 'inter',
            fontWeight: '500',
            lineHeight: '28px',
            fontSize: '17px',
          },
          type: 'typography',
        },
      },
      '600': {
        default: {
          value: {
            fontFamily: 'inter',
            fontWeight: '600',
            lineHeight: '24px',
            fontSize: '17px',
          },
          type: 'typography',
        },
      },
    },
    accent: {
      '1': {
        value: {
          fontFamily: 'Inter',
          fontWeight: '800',
          lineHeight: '78px',
          fontSize: '80px',
        },
        type: 'typography',
      },
      '2': {
        value: {
          fontFamily: 'Inter',
          fontWeight: '800',
          lineHeight: '68px',
          fontSize: '68px',
        },
        type: 'typography',
      },
    },
    h1: {
      value: {
        fontFamily: 'inter',
        fontWeight: '700',
        lineHeight: '52px',
        fontSize: '52px',
      },
      type: 'typography',
    },
    h2: {
      value: {
        fontFamily: 'inter',
        fontWeight: '700',
        lineHeight: '40px',
        fontSize: '36px',
      },
      type: 'typography',
    },
    h3: {
      value: {
        fontFamily: 'inter',
        fontWeight: '700',
        lineHeight: '28px',
        fontSize: '24px',
      },
      type: 'typography',
    },
    caption: {
      '500': {
        value: {
          fontFamily: 'Inter',
          fontWeight: '500',
          lineHeight: '20px',
          fontSize: '15px',
        },
        type: 'typography',
      },
      '600': {
        value: {
          fontFamily: 'Inter',
          fontWeight: '600',
          lineHeight: '20px',
          fontSize: '15px',
        },
        type: 'typography',
      },
    },
  },
  border_radius: {
    s: {
      value: '6px',
      type: 'borderRadius',
    },
    m: {
      value: '16px',
      type: 'borderRadius',
    },
    l: {
      value: '20px',
      type: 'borderRadius',
    },
  },
  height: {
    btn: {
      l: {
        value: '72px',
        type: 'sizing',
      },
      m: {
        value: '64px',
        type: 'sizing',
      },
      s: {
        value: '48px',
        type: 'sizing',
      },
      text: {
        value: '48px',
        type: 'sizing',
      },
    },
    chips: {
      desktop: {
        value: '40px',
        type: 'sizing',
      },
    },
    text_input: {
      desktop: {
        value: '68px',
        type: 'sizing',
      },
    },
    list_item: {
      m: {
        value: '64px',
        type: 'sizing',
      },
      l: {
        value: '72px',
        type: 'sizing',
      },
    },
  },
  horizontal_padding: {
    btn: {
      general: {
        m: {
          value: '32px',
          type: 'sizing',
        },
        s: {
          value: '24px',
          type: 'sizing',
        },
      },
      text: {
        m: {
          value: '16px',
          type: 'sizing',
        },
      },
    },
    drawer: {
      m: {
        value: '56px',
        type: 'sizing',
      },
    },
    accordion: {
      m: {
        value: '32px',
        type: 'sizing',
      },
    },
  },
  shadow: {
    z1: {
      value: {
        x: '0',
        y: '8px',
        blur: '20px',
        spread: '0',
        color: '#00000005',
        type: 'innerShadow',
      },
      type: 'boxShadow',
    },
    z2: {
      value: {
        x: '0',
        y: '8px',
        blur: '25px',
        spread: '0',
        color: '#0000000F',
        type: 'innerShadow',
      },
      type: 'boxShadow',
    },
  },
  size: {
    icon: {
      btn: {
        value: '24px',
        type: 'sizing',
      },
      chips: {
        value: '20px',
        type: 'sizing',
      },
      input: {
        value: '24px',
        type: 'sizing',
      },
      list_item: {
        m: {
          value: '48px',
          type: 'sizing',
        },
        l: {
          value: '56px',
          type: 'sizing',
        },
      },
      vertical_text_to_copy: {
        value: '20px',
        type: 'sizing',
      },
    },
  },
  border: {
    btn: {
      secondary: {
        default: {
          value: {
            color: '#313131',
            width: '1px',
          },
          type: 'border',
        },
        hover: {
          value: {
            color: '#313131',
            width: '1px',
          },
          type: 'border',
        },
        disabled: {
          value: {
            color: '#C7C7C7',
            width: '1px',
          },
          type: 'border',
        },
      },
    },
    check_box: {
      default: {
        value: {
          color: '#D9D9D9',
          width: '1px',
        },
        type: 'border',
      },
      hover: {
        value: {
          color: '#313131',
          width: '1px',
        },
        type: 'border',
      },
      checked: {
        value: {
          color: '#D9D9D9',
          width: '1px',
        },
        type: 'border',
      },
      disabled: {
        value: {
          color: '#E6E6E6',
          width: '1px',
        },
        type: 'border',
      },
      error: {
        value: {
          color: '#F35B1A',
          width: '1px',
        },
        type: 'border',
      },
    },
    input: {
      default: {
        value: {
          color: '#D9D9D9',
          width: '1px',
        },
        type: 'border',
      },
      disabled: {
        value: {
          color: '#E6E6E6',
          width: '1px',
        },
        type: 'border',
      },
      error: {
        value: {
          color: '#F35B1A',
          width: '1px',
        },
        type: 'border',
      },
      focus: {
        value: {
          color: '#313131',
          width: '1px',
        },
        type: 'border',
      },
    },
    chips: {
      default: {
        value: {
          color: '#D9D9D9',
          width: '1px',
        },
        type: 'border',
      },
      disabled: {
        value: {
          color: '#E6E6E6',
          width: '1px',
        },
        type: 'border',
      },
    },
    big_block: {
      outlined: {
        default: {
          value: {
            color: '#ECECEC',
            width: '1px',
          },
          type: 'border',
        },
      },
    },
    menu_item: {
      secondary: {
        selected: {
          value: {
            width: '1px',
            color: '#E8E8E8',
          },
          type: 'border',
        },
      },
    },
  },
  vertical_padding: {
    accordion: {
      m: {
        value: '24px',
        type: 'sizing',
      },
    },
  },
  animation: {
    s: {
      value: '100 ease-in-out',
      type: 'other',
      description: 'animation',
    },
    m: {
      value: '300 ease-in-out',
      type: 'other',
      description: 'animation',
    },
  },
  version: {
    value: '23_04_07_1',
    type: 'other',
    description: 'YY_MM_DD_Version',
  },
}
